<template>
  <div class="splash-screen">
    <div class="splash-content">
      <!-- Logo with animation -->
      <div class="logo-container">
        <img src="@/assets/cf-logo-mini.svg" alt="ChildFriendly" class="logo" />
      </div>

      <!-- Loading animation -->
      <div class="loading-container">
        <p class="loading-text">Loading...</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Simple splash component - controlled by App.vue
</script>

<style lang="sass" scoped>
.splash-screen
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  width: 100vw
  height: 100vh
  background: var(--color-nav-bg)
  display: flex
  align-items: center
  justify-content: center
  z-index: 9999

.splash-content
  display: flex
  flex-direction: column
  align-items: center
  gap: 48px

.logo-container
  position: relative
  animation: logoFloat 2s ease-in-out infinite

  &::before
    content: ''
    position: absolute
    inset: -20px
    background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%)
    border-radius: 50%
    animation: logoGlow 2s ease-in-out infinite

.logo
  width: 140px
  height: 140px
  filter: drop-shadow(var(--shadow-4))
  animation: logoPulse 2s ease-in-out infinite

.loading-container
  display: flex
  flex-direction: column
  align-items: center

.loading-text
  color: white
  font-size: 1.125rem
  font-weight: 600
  margin: 0
  letter-spacing: 0.5px
  animation: textFade 2s ease-in-out infinite

// Animations
@keyframes logoFloat
  0%, 100%
    transform: translateY(0)
  50%
    transform: translateY(-15px)

@keyframes logoPulse
  0%, 100%
    transform: scale(1)
  50%
    transform: scale(1.08)

@keyframes logoGlow
  0%, 100%
    opacity: 0.5
    transform: scale(1)
  50%
    opacity: 0.8
    transform: scale(1.1)

@keyframes textFade
  0%, 100%
    opacity: 0.7
  50%
    opacity: 1

// Responsive
@media (max-width: 768px)
  .logo
    width: 110px
    height: 110px

  .loading-text
    font-size: 1rem
</style>
